/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendSalaryDto } from '../../models/backend-salary-dto';

export interface OpexesSalaryList$Params {
  /**
   * id Варианта
   */
  variant?: number;
}

export function opexesSalaryList(
  http: HttpClient,
  rootUrl: string,
  params?: OpexesSalaryList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendSalaryDto>>> {
  const rb = new RequestBuilder(rootUrl, opexesSalaryList.PATH, 'get');
  if (params) {
    rb.query('variant', params.variant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendSalaryDto>>;
    }),
  );
}

opexesSalaryList.PATH = '/api/opexes/salary/';
